/**
 * @fileoverview A global media size helper. It will tell you which experience
 *   the user is receiving (desktop, tablet, or mobile).
 * @author Nathan Buchar <nathan.buchar@odopod.com>
 * @since 1.0.0
 */

const Media = () => {};

/**
 * @enum {string}
 * @description Media size definitions.
 */
Media.Settings = {
  MOBILE: '(max-width: 767px)',
  TABLET: '(min-width: 768px) and (max-width: 1023px)',
  DESKTOP: '(min-width: 1024px)',
};

/**
 * @method test
 * @description Test a media string.
 * @returns {boolean}
 * @public
 * @static
 */
Media.test = media => window.matchMedia(media).matches;

/**
 * @prop {boolean} isMobile
 * @description Define the `isMobile` getter.
 * @public
 */
Object.defineProperty(Media, 'isMobile', {
  get() {
    return Media.test(Media.Settings.MOBILE);
  },
});

/**
 * @prop {boolean} isTablet
 * @description Define the `isTablet` getter.
 * @public
 */
Object.defineProperty(Media, 'isTablet', {
  get() {
    return Media.test(Media.Settings.TABLET);
  },
});

/**
 * @prop {boolean} isDesktop
 * @description Define the `isDesktop` getter.
 * @public
 */
Object.defineProperty(Media, 'isDesktop', {
  get() {
    return Media.test(Media.Settings.DESKTOP);
  },
});

export default Media;
